<p-message severity="warn" class="mb-4" *ngIf="!loading">
  Admins are able to manage everything except the organization itself, meaning they can manage members, add matches, and import matches.
</p-message>

<div *ngIf="invites.length > 0">
  <div class="flex flex-row py-5 items-center">
    <div class="grow p-3">
      <h2 class="leading-none" style="margin: 0px;">Invite Codes</h2>
    </div>
    <div>
      <p-button (onClick)="createInviteCode()" [disabled]="creatingInviteCode" severity="secondary" icon="bi-plus-circle"
        [label]="creatingInviteCode ? 'Creating...' : 'Create Invite Code'"></p-button>
    </div>
  </div>

  <p-table #invitesTable dataKey="id" [value]="invites">
    <ng-template #header>
      <tr>
        <th>
          Code
        </th>
        <th style="width: 150px;" class="text-right">
          Date Expires
        </th>
        <th style="width: 150px;" class="text-right">
          Date Created
        </th>
        <th style="width: 50px;"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invite>
      <tr>
        <td class="hover:text-amber-500 cursor-pointer" (click)="copyCodeShortcut(invite)" title="Copy code URL shortcut">
          <i class="bi bi-clipboard-fill mr-3 text-blue-500"></i> {{ invite.code }}
        </td>
        <td class="text-right">{{ invite.expires | date: 'dd MMM, yyyy' }}</td>
        <td class="text-right">{{ invite.createdAt | date: 'dd MMM, yyyy' }}</td>
        <th class="text-right">
          <p-button (onClick)="deleteInviteConfirm($event, invite)" severity="danger" icon="bi-trash-fill" title="Remove" size="small"
            variant="text"></p-button>
        </th>
      </tr>
    </ng-template>
  </p-table>
</div>

<div *ngIf="admins.length > 0">
  <div class="flex flex-row py-5 items-center">
    <div class="grow p-3">
      <h2 class="leading-none" style="margin: 0px;">Admins</h2>
    </div>
    <div>
      <p-button (onClick)="createInviteCode()" [disabled]="creatingInviteCode" severity="secondary" icon="bi-plus-circle"
        [label]="creatingInviteCode ? 'Creating...' : 'Create Invite Code'"></p-button>
    </div>
  </div>

  <p>
    These admins can manage everything inside your organization other than the organization.
  </p>

  <p-table #adminsTable dataKey="id" [value]="admins">
    <ng-template #header>
      <tr>
        <th pSortableColumn="user.username">
          Username
        </th>
        <th pSortableColumn="createdAt" style="width: 150px;" class="text-right">
          Added <p-sortIcon field="createdAt" />
        </th>
        <th style="width: 100px;"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-admin>
      <tr>
        <td>{{ getUsername(admin) }}</td>
        <td class="text-right">{{ admin.createdAt | date: 'dd MMM, yyyy' }}</td>
        <th class="text-right">
          <p-button (onClick)="deleteAdminConfirm($event, admin)" severity="danger" icon="bi-trash-fill" title="Remove" size="small"
            variant="text"></p-button>
        </th>
      </tr>
    </ng-template>
  </p-table>
</div>

<tr-alert *ngIf="!loading && admins.length === 0" severity="primary" class="text-center mt-4">
  <p class="text-xl">
    No admins were found, create an invite code.
  </p>
  <p-button (onClick)="createInviteCode()" [disabled]="creatingInviteCode" severity="secondary" icon="bi-plus-circle"
    [label]="creatingInviteCode ? 'Creating...' : 'Create Invite Code'"></p-button>
</tr-alert>

<div *ngIf="loading">
  <tr-alert severity="warning" class="text-center">
    <span class="m-0 p-0 text-4xl site-font">Loading admins</span>
  </tr-alert>
</div>


<p-confirmdialog #cd>
  <ng-template #footer>
    <div class="flex justify-between w-full">
      <p-button type="button" severity="secondary" (onClick)="cd.close($event)" variant="text">Cancel</p-button>
      <p-button type="button" icon="bi bi-trash-fill" severity="danger" label="Remove" (onClick)="cd.onAccept()"></p-button>
    </div>
  </ng-template>
</p-confirmdialog>